import Cookies from 'js-cookie';
import { HeadersType } from '../types';

function throttle(fn: Function, delay: number) {
  // 初始化定时器
  let timer: any = null;
  // 上一次调用时间
  let prev: any = null;
  // 返回闭包函数
  return function(this: any, ...args: any) {
    // 现在触发事件时间
    let now = Date.now();
    // 触发间隔是否大于delay
    let remaining = delay - (now - prev);
    // 保存事件参数
    // 清除定时器
    clearTimeout(timer);
    // 如果间隔时间满足delay
    if (remaining <= 0) {
      // 调用fn，并且将现在的时间设置为上一次执行时间
      fn.apply(this, args);
      prev = Date.now();
    } else {
      // 否则，过了剩余时间执行最后一次fn
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    }
  };
}
export { throttle };

let headers: HeadersType = {
  appId: '',
  appKey: '',
  appVersion: '',
  appClient: '',
  appStage: '',
  appGwVersion: 2,
  appSecrerKey: '',
  appDeviceid: '',
  requestUrl: '',
  ssoLoginUrl: '',
  handleToken: true,
};
export function getHeader() {
  return headers;
}
export function setHeader({
  appId = '',
  appKey = 'gwork',
  appVersion,
  appClient = 'WEB',
  appStage = 'PROD',
  appGwVersion = 2,
  appSecrerKey = '86c7b7dbc28c44df92124c2fbbe77d2b',
  appDeviceid = '',
  requestUrl = '',
  ssoLoginUrl = '',
  handleToken = true,
}: HeadersType) {
  headers = {
    appId,
    appKey,
    appVersion,
    appGwVersion,
    appSecrerKey,
    appStage,
    appClient,
    appDeviceid,
    requestUrl,
    ssoLoginUrl,
    handleToken,
  };
}

export function uniqBy(array = [], iteratee: any) {
  const seen = new Map(); // 创建一个空的哈希表

  return array.filter(item => {
    const key =
      typeof iteratee === 'function' ? iteratee(item) : item[iteratee]; // 使用迭代函数获取每个元素的键
    if (!seen.has(key)) {
      // 如果哈希表中不存在该键，则将其添加到哈希表中
      seen.set(key, true);
      return true; // 返回true，表示该元素是唯一的
    }

    return false; // 返回false，表示该元素是重复的
  });
}

export function replaceUrlWithHost(url: any, host?: string, isEgov?: boolean) {
  // 如果桌面端共有需要处理
  if (!url) return;
  let nowUrl = changeHost(url, host, isEgov);
  let addressMap = {
    'eefs.jzb.beijing.egov.cn': 'jzb.beijing.egov.cn/eefs',
    'oss.jzb.beijing.egov.cn': 'jzb.beijing.egov.cn/oss',
    'joyspace.jzb.beijing.egov.cn': 'jzb.beijing.egov.cn/joyspace',
    'otjoyspace.jzb.beijing.egov.cn': 'jzb.beijing.egov.cn/joyspace-ot',
    'apijoyspace.jzb.beijing.egov.cn': 'jzb.beijing.egov.cn/joyspace-api',

    'eefs.jzb.beijing.gov.cn': 'jzb.beijing.gov.cn/eefs',
    'oss.jzb.beijing.gov.cn': 'jzb.beijing.gov.cn/oss',
    'joyspace.jzb.beijing.gov.cn': 'jzb.beijing.gov.cn/joyspace',
    'otjoyspace.jzb.beijing.gov.cn': 'jzb.beijing.gov.cn/joyspace-ot',
    'apijoyspace.jzb.beijing.gov.cn': 'jzb.beijing.gov.cn/joyspace-api',
  } as any;

  let hostname = nowUrl.replace(/https?:\/\/|wss?:\/\//, '').split('/')[0];
  let newHost = addressMap[hostname];
  if (newHost && hostname !== newHost) {
    nowUrl = nowUrl.replace(hostname, newHost);
  }
  console.log('replaceUrlWithHost url', nowUrl);
  return nowUrl;
}
export function changeHost(url: any, host?: string, isEgov?: boolean) {
  if (!url) return;
  const currentHost = isEgov
    ? 'beijing.egov.cn'
    : host || (typeof location === 'object' ? location.host || '' : '');
  if (
    (currentHost.indexOf('beijing.egov.cn') === -1 &&
      url.indexOf('beijing.egov.cn') === -1) ||
    (currentHost.indexOf('beijing.egov.cn') > -1 &&
      url.indexOf('beijing.egov.cn') > -1)
  ) {
    return url;
  }
  let govAddressMap: Record<string, string> = {
    'eefs.jzb.beijing.egov.cn': 'jzb.beijing.gov.cn/eefs',
    'jzb.beijing.egov.cn/eefs': 'jzb.beijing.gov.cn/eefs',

    'oss.jzb.beijing.egov.cn': 'jzb.beijing.gov.cn/oss',
    'jzb.beijing.egov.cn/oss': 'jzb.beijing.gov.cn/oss',

    'joyspace.jzb.beijing.egov.cn': 'jzb.beijing.gov.cn/joyspace',
    'jzb.beijing.egov.cn/joyspace': 'jzb.beijing.gov.cn/joyspace',

    'jzb.beijing.egov.cn': 'jzb.beijing.gov.cn',
    'app.jzb.beijing.egov.cn': 'app.jzb.beijing.gov.cn',
    'wps.jzb.beijing.egov.cn': 'wps.jzb.beijing.gov.cn',

    'jzb.beijing.egov.cn/oss/focus-desktop':
      'focus-desktop.s3.cn-north-1.jdcloud-oss.com',

    'otjoyspace.jzb.beijing.egov.cn': 'jzb.beijing.gov.cn/joyspace-ot',
    'jzb.beijing.egov.cn/joyspace-ot': 'jzb.beijing.gov.cn/joyspace-ot',

    'apijoyspace.jzb.beijing.egov.cn': 'jzb.beijing.gov.cn/joyspace-api',
    'jzb.beijing.egov.cn/joyspace-api': 'jzb.beijing.gov.cn/joyspace-api',
  };
  let egovAddressMap: Record<string, string> = {
    'eefs.jzb.beijing.gov.cn': 'jzb.beijing.egov.cn/eefs',
    'jzb.beijing.gov.cn/eefs': 'jzb.beijing.egov.cn/eefs',
    'jzb-eefs.jdcloud.com': 'jzb.beijing.egov.cn/eefs',

    'oss.jzb.beijing.gov.cn': 'jzb.beijing.egov.cn/oss',
    'jzb.beijing.gov.cn/oss': 'jzb.beijing.egov.cn/oss',
    'jzb-oss.jdcloud.com': 'jzb.beijing.egov.cn/oss',

    'joyspace.jzb.beijing.gov.cn': 'jzb.beijing.egov.cn/joyspace',
    'jzb-joyspace.jdcloud.com': 'jzb.beijing.egov.cn/joyspace',
    'jzb.beijing.gov.cn/joyspace': 'jzb.beijing.egov.cn/joyspace',

    'jzb.beijing.gov.cn': 'jzb.beijing.egov.cn',
    'jzb.jdcloud.com': 'jzb.beijing.egov.cn',

    'app.jzb.beijing.gov.cn': 'app.jzb.beijing.egov.cn',

    'eepaas-public.s3.cn-north-1.jdcloud-oss.com': 'jzb.beijing.egov.cn/oss',
    'wps.jzb.beijing.gov.cn': 'wps.jzb.beijing.egov.cn',
    'focus-desktop.s3.cn-north-1.jdcloud-oss.com':
      'jzb.beijing.egov.cn/oss/focus-desktop',

    'otjoyspace.jzb.beijing.gov.cn': 'jzb.beijing.egov.cn/joyspace-ot',
    'jzb.beijing.gov.cn/joyspace-ot': 'jzb.beijing.egov.cn/joyspace-ot',

    'apijoyspace.jzb.beijing.gov.cn': 'jzb.beijing.egov.cn/joyspace-api',
    'jzb.beijing.gov.cn/joyspace-api': 'jzb.beijing.egov.cn/joyspace-api',
  } as any;
  // eslint-disable-next-line array-callback-return
  // Object.keys(egovAddressMap).map((item: any) => {
  //   if(item.indexOf('jdcloud') === -1) {
  //     govAddressMap[egovAddressMap[item]] = item;
  //   }
  // })
  if (url) {
    if (currentHost.indexOf('beijing.egov.cn') > -1) {
      try {
        let hostname = url.replace(/https?:\/\/|wss?:\/\//, '').split('/')[0];
        let newHost = egovAddressMap[hostname];
        if (newHost) {
          url = url.replace(hostname, newHost);
        }
      } catch (e) {
        console.log('切换政务外网地址出异常', e);
      }
    } else {
      try {
        let hostname = url.replace(/https?:\/\/|wss?:\/\//, '').split('/')[0];
        let newHost = govAddressMap[hostname];
        if (newHost) {
          url = url.replace(hostname, newHost);
        }
      } catch (e) {
        console.log('切换政务外网地址出异常', e);
      }
    }
  }
  console.log('replaced url', url);
  return url;
}
